export default class Trigger {
	static subscribe(type, event) {
		if (!Trigger._events)
			Trigger._events = {};

		if (!Trigger._events[type])
			Trigger._events[type] = [];

		if (!Trigger._events[type].includes(event))
			Trigger._events[type].push(event);
	}

	static event(type, data) {
		if (!Trigger._events)
			Trigger._events = {};

		if (Trigger._events[type])
			for (let event of Trigger._events[type])
				try { event(data); }
				catch (error) { console.error(error); }
	}
}